var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TimeSpentOnWorkActivitiesUserChart } from '@web/components/Dashboard/TimeSpentOnWorkActivities/TimeSpentOnWorkActivitiesUserChart';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { PeriodBarChart } from '@web/components/layout/RechartsItems/PeriodBarChart';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig, TIME_SPENT_ON_WORK_ACTIVITIES_ENTITY_CHART_COLORS } from '@web/config';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter } from '@web/utility/ tooltip/periodComparisonTooltip';
import { ComparisonPeriod, navigateToEventsLogFromChartPeriod, resolveChartBarPeriodIndex } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { buildTimeSpentOnWorkActivitiesEntityChartData, buildTimeSpentOnWorkActivitiesEntityChartSegments, buildTimeSpentOnWorkActivitiesEntityLegendItems } from '@web/utility/timeSpentOnWorkActivitiesCharts';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { formatDuration } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var TimeSpentOnWorkActivities = function (_a) {
    var _b, _c, _d, _e, _f;
    var data = _a.data, previousData = _a.previousData, teamAverage = _a.teamAverage, _g = _a.userId, userId = _g === void 0 ? null : _g, _h = _a.orgUnitId, orgUnitId = _h === void 0 ? null : _h, interval = _a.interval, dateFrom = _a.dateFrom, dateTo = _a.dateTo, refetch = _a.refetch;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var groupEntitiesByUser = orgUnitId != null;
    if (userId) {
        return (_jsx(TimeSpentOnWorkActivitiesUserChart, { data: data, previousData: previousData, teamAverage: teamAverage, userId: userId, interval: interval, dateFrom: dateFrom, dateTo: dateTo, refetch: refetch }));
    }
    var chartData = buildTimeSpentOnWorkActivitiesEntityChartData((_b = data.byType) !== null && _b !== void 0 ? _b : [], (_c = previousData.byType) !== null && _c !== void 0 ? _c : [], (_d = data.byEntity) !== null && _d !== void 0 ? _d : [], (_e = previousData.byEntity) !== null && _e !== void 0 ? _e : [], { interval: interval, dateFrom: dateFrom, dateTo: dateTo });
    var segments = buildTimeSpentOnWorkActivitiesEntityChartSegments((_f = data.byEntity) !== null && _f !== void 0 ? _f : []);
    var seriesColors = segments.map(function (_, index) {
        return TIME_SPENT_ON_WORK_ACTIVITIES_ENTITY_CHART_COLORS[index % TIME_SPENT_ON_WORK_ACTIVITIES_ENTITY_CHART_COLORS.length];
    });
    var legendItems = buildTimeSpentOnWorkActivitiesEntityLegendItems(data.byEntity, previousData.byEntity);
    var entityMetricLabels = Object.fromEntries(segments.flatMap(function (segment) { return [
        [segment.previousKey, segment.title],
        [segment.currentKey, segment.title]
    ]; }));
    var seriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter(entityMetricLabels);
    var previousStackDataKeys = segments.map(function (segment) { return segment.previousKey; });
    var currentStackDataKeys = segments.map(function (segment) { return segment.currentKey; });
    var tooltipSeriesOrder = __spreadArray(__spreadArray([], previousStackDataKeys, true), currentStackDataKeys, true);
    var renderTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: tooltipSeriesOrder, periodComparisonTooltip: true, seriesLabelFormatter: seriesLabelFormatter, formatValue: function (value) { return formatDuration(value, 'hours'); } }), chartData.length);
    var handleEntityBarClick = function (entityId, stack, barData, fallbackIndex) {
        var _a;
        var periodIndex = resolveChartBarPeriodIndex(chartData, barData, fallbackIndex);
        navigateToEventsLogFromChartPeriod({
            navigateTo: navigateTo,
            periodIndex: periodIndex,
            periodLabel: (_a = chartData[periodIndex]) === null || _a === void 0 ? void 0 : _a.period,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: groupEntitiesByUser ? entityId : null,
            orgUnitId: groupEntitiesByUser ? null : entityId,
            stack: stack
        });
    };
    var exportData = chartData.map(function (row) {
        var _a;
        var entry = (_a = {},
            _a[t('filters.period')] = row.period,
            _a);
        segments.forEach(function (segment) {
            var _a, _b;
            entry["".concat(t('export.previous'), " ").concat(segment.title)] =
                (_a = row[segment.previousKey]) !== null && _a !== void 0 ? _a : 0;
            entry["".concat(t('export.current'), " ").concat(segment.title)] =
                (_b = row[segment.currentKey]) !== null && _b !== void 0 ? _b : 0;
        });
        return entry;
    });
    var legendTitles = segments.map(function (segment) { return segment.title; });
    var insightsChartData = chartData.map(function (row) {
        var entry = { name: row.period };
        segments.forEach(function (segment) {
            var _a, _b;
            entry[segment.currentKey] = Number((_a = row[segment.currentKey]) !== null && _a !== void 0 ? _a : 0);
            entry[segment.previousKey] = Number((_b = row[segment.previousKey]) !== null && _b !== void 0 ? _b : 0);
        });
        return entry;
    });
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.dashboard.timeSpentOnWorkActivities'), description: "widgetTitleDescriptions.dashboard.timeSpentOnWorkActivities", insightType: InsightTypeEnum.timeSpentOnWorkActivities, insightsData: insightsChartData, labels: legendTitles, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.dashboard.timeSpentOnWorkActivities'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, exportData];
                    }); }); }, disabled: isAiButtonDisabled(insightsChartData) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: legendTitles }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsx(PeriodBarChart, { chartData: chartData, dateFrom: dateFrom, dateTo: dateTo, interval: interval, barsPerGroup: 2, tooltipContent: renderTooltip, yAxisTickFormatter: function (value) { return formatDuration(value, 'hours'); }, chartHeight: 380, legend: legendItems.length > 0 ? (_jsx("div", __assign({ className: "flex flex-col flex-wrap justify-start gap-2 lg:flex-row lg:gap-4" }, { children: legendItems.map(function (_a, index) {
                                var id = _a.id, title = _a.title, currentTotal = _a.currentTotal, diffValue = _a.diffValue;
                                return (_jsx(LegendItem, { color: seriesColors[index].color, label: title, currentValue: formatDuration(currentTotal, 'seconds'), diffValue: diffValue, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(title); }, isHidden: !isSeriesVisible(title) }, id));
                            }) }))) : null, stacks: [
                            {
                                stackId: 'prev',
                                segments: segments.map(function (segment, index) { return ({
                                    dataKey: segment.previousKey,
                                    fill: seriesColors[index].prevChartColor,
                                    keyPrefix: "prev-".concat(segment.id),
                                    hide: !isSeriesVisible(segment.title),
                                    onClick: function (barData, barIndex) {
                                        return handleEntityBarClick(segment.id, ComparisonPeriod.Previous, barData, barIndex);
                                    }
                                }); })
                            },
                            {
                                stackId: 'curr',
                                segments: segments.map(function (segment, index) { return ({
                                    dataKey: segment.currentKey,
                                    fill: seriesColors[index].chartColor,
                                    keyPrefix: "curr-".concat(segment.id),
                                    hide: !isSeriesVisible(segment.title),
                                    onClick: function (barData, barIndex) {
                                        return handleEntityBarClick(segment.id, ComparisonPeriod.Current, barData, barIndex);
                                    }
                                }); })
                            }
                        ] }));
                } }))] })));
};
export default TimeSpentOnWorkActivities;
